import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Instagram, Facebook } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1e1919] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_a6659117-80bd-44e6-b635-f0178e8af557/artifacts/c3g6j18u_SM.png" 
              alt="Speaking Mirror" 
              className="h-12 w-auto"
            />
            <p className="text-[#bbb5ae] text-sm leading-relaxed">
              Full-scale marketing agency specializing in Digital Marketing & Content Creation.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/speakingmirror" target="_blank" rel="noopener noreferrer" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="https://www.instagram.com/speakingmirror" target="_blank" rel="noopener noreferrer" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="https://x.com/speaking_mirror" target="_blank" rel="noopener noreferrer" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.facebook.com/speakingmirrorsays" target="_blank" rel="noopener noreferrer" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/our-story" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors text-sm">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/capabilities" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors text-sm">
                  Capabilities
                </Link>
              </li>
              <li>
                <Link to="/the-work" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors text-sm">
                  The Work
                </Link>
              </li>
              <li>
                <Link to="/brands" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors text-sm">
                  Brands
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <Link to="/capabilities" className="text-lg font-bold mb-4 block hover:text-[#fa551e] transition-colors">Services</Link>
            <ul className="space-y-2 text-sm">
              <li><Link to="/capabilities" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">Social Media Marketing</Link></li>
              <li><Link to="/capabilities" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">SEO Optimization</Link></li>
              <li><Link to="/capabilities" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">Content Creation</Link></li>
              <li><Link to="/capabilities" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">Performance Marketing</Link></li>
              <li><Link to="/capabilities" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">Brand Strategy</Link></li>
              <li><Link to="/capabilities" className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">Influencer Marketing</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <Mail size={18} className="mt-0.5 flex-shrink-0 text-[#bbb5ae]" />
                <a href={`mailto:${contactInfo.email}`} className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">{contactInfo.email}</a>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <Phone size={18} className="mt-0.5 flex-shrink-0 text-[#bbb5ae]" />
                <a href={`tel:${contactInfo.phone}`} className="text-[#bbb5ae] hover:text-[#fa551e] transition-colors">{contactInfo.phone}</a>
              </li>
              {contactInfo.offices.map((office) => (
                <li key={office.city}>
                  <a href={office.mapUrl} target="_blank" rel="noopener noreferrer" className="flex items-start space-x-2 text-sm text-[#bbb5ae] hover:text-[#fa551e] transition-colors">
                    <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="font-semibold text-white">{office.city}</p>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#61525a] pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#bbb5ae] text-sm">
              © {currentYear} Speaking Mirror. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-[#bbb5ae]">
              <Link to="/privacy-policy" className="hover:text-[#fa551e] transition-colors">Privacy Policy</Link>
              <Link to="/terms-of-service" className="hover:text-[#fa551e] transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
